import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';
import * as media from '../../../assets/career/media';
import { careerUrls } from '../../../utils/careerUrls';

export const Vacancies: React.FC = () => (
  <section className={cx('main_section_vacancies')}>
    <div className={cx('padding-global padding-section-large')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_vacancies')}>
          <div className={cx('main_vacancies_top-wrapper')}>
            <h2>
              {'Двигай вместе '}
              <span className={cx('text-color-brand-green')}>
                <br />
                {'с нами'}
              </span>
            </h2>
            <div className={cx('spacer-medium')}></div>
            <div className={cx('text-size-large')}>
              {'Найди свою команду — мы поможем '}
              <br />
              {'со всем остальным.'}
            </div>
          </div>
          <a href={careerUrls.vacancies()} className={cx('button is-big max-width-full-mobile-landscape w-button')}>
            {'Смотреть вакансии'}
          </a>
          <img
            src={media.mainVacanciesBoyImage}
            loading="lazy"
            sizes="100vw"
            srcSet={[
              media.mainVacanciesBoyImageP500 + ' 500w',
              media.mainVacanciesBoyImageP800 + ' 800w',
              media.mainVacanciesBoyImageP1080 + ' 1080w',
              media.mainVacanciesBoyImageP1600 + ' 1600w',
              media.mainVacanciesBoyImage + ' 1797w',
            ].join(', ')}
            alt=""
            className={cx('main_vacancies_boy-image')}
          />
          <img
            src={media.mainVacanciesPhoto1}
            loading="lazy"
            sizes="100vw"
            alt=""
            srcSet={[
              media.mainVacanciesPhoto1P500 + ' 500w',
              media.mainVacanciesPhoto1P800 + ' 800w',
              media.mainVacanciesPhoto1 + ' 826w',
            ].join(', ')}
            className={cx('main_vacancies_photo-1')}
          />
          <img
            src={media.mainVacanciesPhoto2}
            loading="lazy"
            sizes="100vw"
            alt=""
            srcSet={[
              media.mainVacanciesPhoto2P500 + ' 500w',
              media.mainVacanciesPhoto2P800 + ' 800w',
              media.mainVacanciesPhoto2 + ' 872w',
            ].join(', ')}
            className={cx('main_vacancies_photo-2')}
          />
          <img
            src={media.mainVacanciesPhoto3}
            loading="lazy"
            sizes="100vw"
            alt=""
            srcSet={[
              media.mainVacanciesPhoto3P500 + ' 500w',
              media.mainVacanciesPhoto3P800 + ' 800w',
              media.mainVacanciesPhoto3 + ' 834w',
            ].join(', ')}
            className={cx('main_vacancies_photo-3')}
          />
        </div>
      </div>
    </div>
  </section>
);
